import { css } from '@emotion/core';
import { pTag, media, fontXsmall, fontBase } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export
export const container = css`
  p {
    ${pTag};
    ${fontXsmall}
    line-height: 24px; // this is intentional
    ${media('>=desktop')} {
      ${fontBase}
    }
  }
`;
